import useUserList from './useUserList';
import { Table, TableBody, TableCell, TableContainer } from 'components/mui';
import {
	TableHead,
	TablePagination,
	TableRow,
	TableSortLabel,
} from 'components/mui';
import { Collapse, FormControlLabel, IconButton, Switch } from 'components/mui';
import { getComparator, stableSort } from 'libs/sortList';
import { AddIcon, RemoveIcon } from 'components/icons';
import { ActionsComp } from 'components';
import { UserEditForm } from 'containers/pages/users/components';
import styles from './UserList.module.css';
import { array, func } from 'prop-types';
import User from '../../constants/user';

/**
 * @component UserList
 * @param {Object} props
 * @param {UserGroup[]} props.userGroups
 * @param {function} props.handleMode
 * @returns {JSX.Element}
 */
function UserList({ handleMode, userGroups }) {
	const { state, handler } = useUserList();

	const renderedTableHead = state.headTableCell.map((cell) => (
		<TableCell
			key={cell.id}
			sortDirection={state.orderBy === cell.id ? state.order : false}
		>
			<TableSortLabel
				active={state.orderBy === cell.id}
				direction={state.orderBy === cell.property ? state.order : 'asc'}
				onClick={handler.onSort(cell.property)}
			>
				{cell.label}
				{state.orderBy === cell.id ? (
					<span className={styles.visuallyHidden}>
						{state.order === 'desc'
							? 'sorted descending'
							: 'sorted ascending'}
					</span>
				) : null}
			</TableSortLabel>
		</TableCell>
	));

	const renderedTableBody = stableSort(
		state.users,
		getComparator(state.order, state.orderBy),
	)
		.slice(
			state.page * state.rowsPerPage,
			state.page * state.rowsPerPage + state.rowsPerPage,
		)
		.map((user) => (
			<TableRow key={user[User.Id]}>
				<TableCell className={styles.table_cell_icon}>
					<IconButton onClick={() => handler.onForm(user.id)}>
						{state.selectedIds.includes(user[User.Id]) ? (
							<RemoveIcon />
						) : (
							<AddIcon />
						)}
					</IconButton>
				</TableCell>
				{state.selectedIds.includes(user[User.Id]) ? (
					<TableCell colSpan={7}>
						<Collapse
							in={state.selectedIds.includes(user[User.Id])}
						>
							<UserEditForm
								id={user[User.Id]}
								onResetId={handler.onResetSelectedIds}
								handleMode={handleMode}
								userGroups={userGroups}
							/>
						</Collapse>
					</TableCell>
				) : (
					<>
						<TableCell>{user[User.FirstName]}</TableCell>
						<TableCell>{user[User.LastName]}</TableCell>
						<TableCell>{user[User.PhoneWork]}</TableCell>
						<TableCell>{user[User.EmailWork]}</TableCell>
						<TableCell>{user[User.Username]}</TableCell>
						<TableCell>{user.custName}</TableCell>
						<TableCell>{user[User.IsEnabled]}</TableCell>
					</>
				)}
			</TableRow>
		));

	return (
		<section className={styles.section}>
			<TableContainer className={styles.table_container}>
				<Table size={state.dense ? 'small' : 'medium'}>
					<TableHead>
						<TableRow>{renderedTableHead}</TableRow>
					</TableHead>
					<TableBody>{renderedTableBody}</TableBody>
				</Table>
			</TableContainer>
			<div className={styles.footer}>
				<FormControlLabel
					className={styles.form_control_label}
					control={
						<Switch
							checked={state.dense}
							onChange={handler.onDense}
						/>
					}
					label="Dense"
				/>
				<TablePagination
					className={styles.pagination}
					component="div"
					rowsPerPageOptions={[
						5,
						10,
						25,
						{ label: 'All', value: -1 },
					]}
					colSpan={3}
					count={state.users.length}
					rowsPerPage={state.rowsPerPage}
					page={state.page}
					onRowsPerPageChange={handler.onRowsPerPage}
					onPageChange={handler.onPage}
					ActionsComponent={ActionsComp}
				/>
			</div>
		</section>
	);
}

UserList.propTypes = {
	userGroups: array,
	handleMode: func,
};

export default UserList;
